<template>
  <div class="payment-confirm-pane">
    <credit-card-confirm-section />

    <action-buttons-section
      class="payment-confirm-pane__action-buttons"
      scrollTargetSelector=".payment-confirm-pane"
      :visible="true"
    >
      <atom-input-button
        :linkText="$tc('common.registration')"
        :isDisabled="false"
        @push="handlerSubmit()"
      />

      <atom-input-button
        :linkText="$tc('common.back')"
        :isDisabled="false"
        colorType="tertiary"
        @push="handlerCancel()"
      />
    </action-buttons-section>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import ActionButtonsSection from '@/components/common/form/ActionButtonsSection.vue'
import AtomInputButton from '@/components/atoms/input/AtomInputButton.vue'
import CreditCardConfirmSection from '@/components/common/payment/CreditCardConfirmSection.vue'

/**
 * クレジットカード情報変更確認画面 ペイン
 */
export default defineComponent({
  name: 'PaymentConfirmPane',
  components: {
    ActionButtonsSection,
    AtomInputButton,
    CreditCardConfirmSection,
  },
  methods: {
    handlerSubmit() {
      /**
       * todo: 完了画面遷移処理
       */
      this.$router.push('/payment/complete')
    },
    handlerCancel() {
      /**
       * todo: キャンセル処理
       */
      this.$router.push('/payment/edit')
    },
  },
})
</script>

<style lang="scss" scoped>
.payment-confirm-pane {
  width: 100%;
  padding-bottom: 160px;
  color: $gray75;
  background: $gray1;

  &__action-buttons {
    bottom: 0;
  }
}
</style>

<style lang="scss">
.payment-confirm-pane {
  &__action-buttons {
    .action-buttons-section__inner {
      @media screen and (min-width: $responsiveTabletWidth) {
        flex-direction: row-reverse;
      }
    }
  }
}
</style>
